import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
interface ImageStripProps {
  items: object[];
}
export default function ImageStrip(props) {
  const $ = _c(4);
  const {
    items
  } = props;
  let t0;
  if ($[0] !== items) {
    t0 = items.map(_temp);
    $[0] = items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="mb-2 flex gap-2">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item) {
  return <div key={item.sys.id} className=""><Image src={item.url} alt={item.alt || ""} width={800} height={400} /></div>;
}